import { AnalyticsGradeRow } from '../../../api/types';
import { Segmented } from '../../../components/ui';

interface Props {
  grades: AnalyticsGradeRow[];
  value: number | null;
  onChange: (gradeId: number) => void;
  /** While grades load, render nothing rather than the "No grades yet" hint. */
  loading?: boolean;
  /** Pill text for a grade (design Class performance uses `G10`); defaults to the grade name. */
  formatLabel?: (g: AnalyticsGradeRow) => string;
}

/** Grade choice as horizontal overflow-paging pills (design). */
export default function GradePicker({ grades, value, onChange, loading = false, formatLabel }: Props) {
  if (grades.length === 0) {
    return loading ? null : <p className="text-[13px] text-muted">No grades yet — add them in Classes.</p>;
  }
  return (
    <Segmented scroll label="Grade" value={value == null ? '' : String(value)}
      onChange={(k) => onChange(Number(k))}
      options={grades.map((g) => ({ key: String(g.id), label: formatLabel ? formatLabel(g) : g.name, ...(formatLabel && formatLabel(g) !== g.name ? { title: g.name } : {}) }))} />
  );
}
